
import {
  ChangeDetectionStrategy,
  Component,
  inject,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import {
  MethodContextEnum,
  UnavailableGeneralData,
} from '@personal-area/global/social-authorization/models';
import { IconComponent } from '@personal-area/global/ui';

import { UNAVAILABLE_MODAL_CONFIG } from '../../tokens/config.token';


@Component({
    selector: 'global-unavailable-general-modal',
    imports: [TranslateModule, IconComponent],
    templateUrl: './unavailable-general-modal.component.html',
    styleUrl: './unavailable-general-modal.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnavailableGeneralModalComponent {
  private readonly _dialogRef = inject(
    MatDialogRef<UnavailableGeneralModalComponent>,
  );
  private readonly _data = inject<UnavailableGeneralData>(MAT_DIALOG_DATA);
  private readonly _config = inject(UNAVAILABLE_MODAL_CONFIG);
  private readonly _router = inject(Router);

  public readonly isLoginContext = this._data.context === MethodContextEnum.Login;
  private readonly _prefix = this._config.translationKeyPrefix;

  public readonly titleKey = this.isLoginContext
    ? `${this._prefix}.general.title.sign-in`
    : `${this._prefix}.general.title.sign-up`;

  public readonly buttonKey = `${this._prefix}.general.button`;

  public readonly descriptionKey = (() => {
    const hasTime = Boolean(this._data.time);
    const hasDate = Boolean(this._data.date);
    const context = this.isLoginContext ? 'sign-in' : 'sign-up';

    if (hasTime && hasDate) {
      return `${this._prefix}.general.description-date-time.${context}`;
    }
    if (hasTime) {
      return `${this._prefix}.general.description-time.${context}`;
    }
    return `${this._prefix}.general.description`;
  })();

  public readonly descriptionParams = (() => {
    const params: Record<string, string> = {};

    if (this._data.time) {
      params['time'] = this._data.time;
    }

    if (this._data.date) {
      params['date'] = this._data.date;
    }

    return params;
  })();

  public close(): void {
    this._dialogRef.close();
  }

  public confirm(): void {
    this._dialogRef.close();

    if (this._config.redirectUrl) {
      this._router.navigate([this._config.redirectUrl]);
    }
  }
}
